import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import api, { apiError, notifyChange, todayISO } from "../../lib/api";
import { toast } from "sonner";

const DEFAULT_CATS = ["materiale sanitario", "pulizie", "manutenzione", "acquisti", "utenze", "personale", "altro"];

export default function ExpenseModal({ open, onClose }) {
  const [date, setDate] = useState(todayISO());
  const [category, setCategory] = useState("altro");
  const [cats, setCats] = useState(DEFAULT_CATS);
  const [description, setDescription] = useState("");
  const [supplier, setSupplier] = useState("");
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("contanti");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) api.get("/settings").then(({ data }) => { if (data.expense_categories?.length) setCats(data.expense_categories); }).catch(() => {});
  }, [open]);

  const save = async () => {
    if (!amount || Number(amount) <= 0) { toast.error("Inserisci un importo valido"); return; }
    if (!description.trim()) { toast.error("Inserisci una descrizione"); return; }
    setSaving(true);
    try {
      await api.post("/expenses", { date, category, description, supplier, amount: Number(amount), method, notes });
      toast.success("Spesa registrata");
      notifyChange();
      onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="expense-modal">
        <DialogHeader><DialogTitle className="font-heading text-xl">Registra spesa</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Data</Label><Input data-testid="expense-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="rounded-xl" /></div>
            <div><Label>Importo (€) *</Label><Input data-testid="expense-amount" type="number" min="0" step="0.5" value={amount} onChange={(e) => setAmount(e.target.value)} className="rounded-xl" /></div>
          </div>
          <div>
            <Label>Categoria</Label>
            <Select value={category} onValueChange={setCategory}>
              <SelectTrigger data-testid="expense-category" className="rounded-xl"><SelectValue /></SelectTrigger>
              <SelectContent>{cats.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label>Descrizione *</Label><Input data-testid="expense-description" value={description} onChange={(e) => setDescription(e.target.value)} className="rounded-xl" /></div>
          <div><Label>Fornitore</Label><Input data-testid="expense-supplier" value={supplier} onChange={(e) => setSupplier(e.target.value)} className="rounded-xl" /></div>
          <div>
            <Label>Metodo pagamento</Label>
            <Select value={method} onValueChange={setMethod}>
              <SelectTrigger data-testid="expense-method" className="rounded-xl"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="contanti">Contanti</SelectItem>
                <SelectItem value="carta/POS">Carta/POS</SelectItem>
                <SelectItem value="bonifico">Bonifico</SelectItem>
                <SelectItem value="altro">Altro</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label>Note</Label><Input data-testid="expense-notes" value={notes} onChange={(e) => setNotes(e.target.value)} className="rounded-xl" /></div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" data-testid="expense-cancel-btn" onClick={onClose} className="rounded-full">Annulla</Button>
          <Button data-testid="expense-save-btn" onClick={save} disabled={saving} className="rounded-full">{saving ? "Salvataggio..." : "Registra"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
